import dlv from 'dlv';

import { injectScripts } from '@cube/script-injector';

export function initNewsroom({ taboolaConfig, pageTemplate, pageDashboard }) {
	if (!dlv(taboolaConfig, 'client') || !dlv(taboolaConfig, 'enableNewsroom')) return;

	injectScripts([
		{
			src: `https://c2.taboola.com/nr/${taboolaConfig.client}/newsroom.js`
		}
	]).then(() => {
		window._newsroom = window._newsroom || [];
		if (pageTemplate && pageDashboard) {
			window._newsroom.push({ pageTemplate });
			window._newsroom.push({ pageDashboard });
			window._newsroom.push('auditClicks');
			window._newsroom.push('trackPage');
		}
	});
}
